import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import bulkPodActions from './bulk-pod-actions';

export default {
  state,
  getters,
  actions: {
    ...actions,
    ...bulkPodActions,
  },
  mutations,
};
